import {
	ADMINADDORUPDATEKYCMAPPING_SUCCESS,
	ADMINADDORUPDATEKYCMAPPING_FAILED,
	RESET_ADMINADDORUPDATEKYCMAPPING,
	LOADING_ADMINADDORUPDATEKYCMAPPING,
	NETWORK_ERROR_ADMINADDORUPDATEKYCMAPPING
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminAddOrUpdateKycMapping = () => {
	return { type: RESET_ADMINADDORUPDATEKYCMAPPING };
};

const adminAddOrUpdateKycMapping =
	(userData, authTokenIs) => async (dispatch) => {
		dispatch({ type: LOADING_ADMINADDORUPDATEKYCMAPPING });
		await adminServices
			.post("createOrUpdateKycMapping", userData, { headers: { AuthToken: authTokenIs } })
			.then((res) => {
				switch (res.data.status) {
					case "success":
						dispatch(adminAddOrUpdateKycMappingsuccess(res.data));
						break;
					default:
						dispatch(adminAddOrUpdateKycMappingFailed(res.data));
						break;
				}
			})
			.catch((err) => {
				dispatch({
					type: NETWORK_ERROR_ADMINADDORUPDATEKYCMAPPING,
					payload: err
				});
			});
	};
function adminAddOrUpdateKycMappingsuccess(data) {
	return {
		type: ADMINADDORUPDATEKYCMAPPING_SUCCESS,
		payload: data
	};
}
function adminAddOrUpdateKycMappingFailed(data) {
	return {
		type: ADMINADDORUPDATEKYCMAPPING_FAILED,
		payload: data
	};
}

export { resetAdminAddOrUpdateKycMapping, adminAddOrUpdateKycMapping };
